
import type { ElementType, ReactNode, CSSProperties } from 'react';
import { cx } from '@client/shared/lib/cx.ts';
import styles from './layout.module.css';

export type SpaceToken = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
export type Align = 'start' | 'center' | 'end' | 'baseline' | 'stretch';
export type Justify = 'start' | 'center' | 'end' | 'between';

export const alignClass: Record<Align, string | undefined> = {
  start: styles.alignStart,
  center: styles.alignCenter,
  end: styles.alignEnd,
  baseline: styles.alignBaseline,
  stretch: styles.alignStretch,
};

export const justifyClass: Record<Justify, string | undefined> = {
  start: styles.justifyStart,
  center: styles.justifyCenter,
  end: styles.justifyEnd,
  between: styles.justifyBetween,
};

export function gapVar(gap: SpaceToken | undefined): CSSProperties | undefined {
  if (gap === undefined) return undefined;
  return { ['--gap' as string]: `var(--space-${gap})` };
}

export interface StackProps {
  gap?: SpaceToken;
  align?: Align;
  justify?: Justify;
  as?: ElementType;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

export function Stack({
  gap,
  align,
  justify,
  as: As = 'div',
  className,
  style,
  children,
}: StackProps) {
  return (
    <As
      className={cx(
        styles.stack,
        align && alignClass[align],
        justify && justifyClass[justify],
        className,
      )}
      style={{ ...gapVar(gap), ...style }}
    >
      {children}
    </As>
  );
}
